export class Item {
  name: string;
  name_short: string;
  url: string;
  url_pic: string;
  color: string;
  rating?: number;
  enable: boolean;

  constructor(name: string, name_short: string, url: string, url_pic: string, color: string) {
    this.name = name;
    this.name_short = name_short;
    this.url = url;
    this.url_pic = url_pic;
    this.color = color;
    this.enable = true;
  }
}
